export default __webpack_public_path__ + "5c9142413866f5bf0a2aaa22f5a0a8be.svg";